import { ITerminal } from '../../models/terminal.interface'

/**
 * Widget to display a list of terminals that can be removed and added to a container.
 * 
 * @param {ITerminal} data the terminal list array
 * @param {HTMLElement} container the parent container for the generated list of elements
 * 
 * @returns void
 */
export const terminalListWidget = ( data: Array<ITerminal>, container: HTMLElement ) => {
  if ( !Array.isArray(data) || !container ) return;

  data.forEach((e: ITerminal) => {
    const div = document.createElement('div');
    div.className = `single-row-widget key_${e.terminalId}`;  

    const span = document.createElement('span');
    span.textContent = `${e.terminalName} | ${e.partnerName}`;

    const addButton = document.createElement('a');
    addButton.className = 'aafp_btn-form btn_theme-primary get-selected-element';
    addButton.id = `aafp_add-customer-${e.terminalId}`;
    addButton.textContent = 'SELECT';
    addButton.setAttribute(`data-id`, e.terminalId!);
    addButton.setAttribute('data-name', e.terminalName);
    addButton.setAttribute('data-partner', String(e.partnerId));
    addButton.setAttribute('data-partnername', e.partnerName);

    div.appendChild(span);
    div.appendChild(addButton);

    if ( data.length > 1 ) {
      container.appendChild(div);  
    } else {
      container.prepend(div);  
    }
  });

  data.length = 0;
}